import "./App.css";

import React, {
  createContext,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";

import AboutUs from "./pages/AboutUs/AboutUs";
import AdminConsole from "./pages/AdminConsole/AdminConsole";
import Columns from "./pages/Columns/Columns";
import CookiesStrip from "./components/CookiesStrip/CookiesStrip";
import CustomerConsole from "./pages/CustomerConsole/CustomerConsole";
import Header from "./components/Header/Header";
//pages
import Home from "./pages/Home/Home";
import Loader from "./components/Loader";
import Podcasts from "./pages/Podcasts/Podcasts";
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy";
import ResetPassword from "./pages/ResetPassword/ResetPassword";
import Search from "./pages/Search/Search";
import StoryDetail from "./pages/StoryDetail/StoryDetail";
import SubscriptionPlansNewTable from "./pages/SubscriptionPlans/SubscriptionPlansNewTable";
import TermsOfUse from "./pages/TermsOfUse/TermsOfUse";
import { getUserProfile } from "./services/authService";
import { updateUser } from "./redux/reducers/userReducer";
import { useDispatch } from "react-redux";

export const LoaderContext = createContext({
  loading: false,
  showLoading: (value: boolean) => {},
});

export const Main = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [isLoadingComplete, setIsLoadingComplete] = useState<boolean>(false);

  const dispatch = useDispatch();

  const showLoading = useCallback((value: boolean) => {
    setLoading(value);
  }, []);

  useEffect(() => {
    const email = localStorage.getItem("user_email") || "";
    const fetchUser = async () => {
      try {
        const response: any = await getUserProfile({
          email,
        });
        dispatch(updateUser(response));
        setIsLoadingComplete(true);
      } catch (error) {
        console.log(error);
        setIsLoadingComplete(true);
      }
    };

    if (email) {
      fetchUser();
    } else {
      setIsLoadingComplete(true);
    }
  }, []);

  const contextValue = useMemo(
    () => ({ loading, showLoading }),
    [loading, showLoading]
  );

  return (
    <div className="App">
      <LoaderContext.Provider value={contextValue}>
        <Router>
          <Header />
          {isLoadingComplete ? (
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/Columns" element={<Columns />} />
              <Route path="/Podcasts" element={<Podcasts />} />
              <Route path="/AboutUs" element={<AboutUs />} />
              <Route path="/Search" element={<Search />} />
              <Route path="/AdminConsole" element={<AdminConsole />} />
              <Route path="/CustomerConsole" element={<CustomerConsole />} />

              <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
              <Route path="/TermsOfUse" element={<TermsOfUse />} />
              <Route path="/ResetPassword" element={<ResetPassword />} />

              <Route path="/Details/:id" element={<StoryDetail />} />
              <Route
                path="/SubscriptionPlans"
                element={<SubscriptionPlansNewTable />}
              />
            </Routes>
          ) : null}
          <CookiesStrip />
          {loading && <Loader />}
        </Router>
      </LoaderContext.Provider>
    </div>
  );
};
